<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('account-number')"
          prop="accountNumber"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.accountNumber"
            @input="form.accountNumber = valueTrimLeft($event)"
            @change="updateModelItem('accountNumber', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('shipper')"
          prop="shipperID"
          class="material-style">
          <select-response-auto-complete
            :model.sync="form.shipperID"
            @update:model="updateModelItem('shipperID', { required: false })"
            api="Shippers/GetAllDynamic"
            :fields="{id: 'id', title: 'shipperName'}"
          ></select-response-auto-complete>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style">
          <el-input
            type="textarea"
            :rows="3"
            :value="form.remarks"
            @input="form.remarks = valueTrimLeft($event)"
            @change="updateModelItem('remarks', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormForwardersShipper',
  mixins: [Form]
}
</script>
